import { createMarketplaceEventFactory } from '../index';
export const getSearchResultClickedEvent = createMarketplaceEventFactory('Marketplace', 'Search Result Clicked');
export const getSearchResultViewedEvent = createMarketplaceEventFactory('Marketplace', 'Search Result Viewed');